// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billings-list-page .muted {
  color: #64748b;
  font-size: 0.8rem;
  margin-top: 2px;
}
.billings-list-page .muted i {
  margin-right: 4px;
  color: #94a3b8;
}
.billings-list-page .p-datatable {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);
}
.billings-list-page .p-datatable-thead > tr > th {
  background: #f9fafb;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #e5e7eb;
}
.billings-list-page .p-datatable-thead > tr > th.num {
  text-align: right;
}
.billings-list-page .p-datatable-tbody > tr > td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}
.billings-list-page .p-datatable-tbody > tr > td.num {
  text-align: right;
}
.billings-list-page .p-datatable-tbody > tr:last-child > td {
  border-bottom: 0;
}
.billings-list-page tr.clickable {
  cursor: pointer;
  transition: background 0.12s;
}
.billings-list-page tr.clickable:hover {
  background: #f0fdfa;
}
.billings-list-page .number {
  font-weight: 700;
  color: #0f172a;
}
.billings-list-page .who {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}
.billings-list-page .who .avatar {
  flex: none;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ccfbf1;
  color: #0f766e;
  font-weight: 700;
  font-size: 0.78rem;
}
.billings-list-page .who .name {
  font-weight: 600;
  color: #0f172a;
}
.billings-list-page .amount {
  font-weight: 700;
  font-size: 1.02rem;
  font-variant-numeric: tabular-nums;
  color: #0f172a;
}
.billings-list-page .status-link {
  display: block;
  margin-top: 4px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 600;
  color: #0f766e;
  cursor: pointer;
}
.billings-list-page .status-link:hover {
  text-decoration: underline;
}
.billings-list-page .actions-col {
  width: 110px;
  text-align: right;
  white-space: nowrap;
}
.billings-list-page .actions-col .p-button + .p-button {
  margin-left: 0.4rem;
}
.billings-list-page .empty {
  text-align: center;
  padding: 2.5rem 1rem !important;
  color: #64748b;
}
@media (max-width: 768px) {
  .billings-list-page th:nth-child(3),
  .billings-list-page td:nth-child(3) {
    display: none;
  }
}
/*# sourceMappingURL=manage-billings.component.css.map */`, "",{"version":3,"sources":["webpack://./manage-billings.component.less","webpack://./src/app/billings/manage-billings/manage-billings.component.less"],"names":[],"mappings":"AAEA;EAEI,cAAA;EACA,iBAAA;EACA,eAAA;ACFJ;ADFA;EAOM,iBAAA;EACA,cAAA;ACFN;ADNA;EAaI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mDAAA;ACJJ;ADbA;EAqBI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gCAAA;ACLJ;ADOI;EACE,iBAAA;ACLN;AD1BA;EAoCI,oBAAA;EACA,gCAAA;EACA,sBAAA;ACPJ;ADSI;EACE,iBAAA;ACPN;ADlCA;EA8CI,gBAAA;ACTJ;ADrCA;EAkDI,eAAA;EACA,4BAAA;ACVJ;ADYI;EACE,mBAAA;ACVN;AD5CA;EA2DI,gBAAA;EACA,cAAA;ACZJ;ADhDA;EAgEI,aAAA;EACA,mBAAA;EACA,WAAA;ACbJ;ADrDA;EAqEM,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ACbN;ADlEA;EAmFM,gBAAA;EACA,cAAA;ACdN;ADtEA;EAyFI,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;AChBJ;AD5EA;EAgGI,cAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;ACjBJ;ADmBI;EACE,0BAAA;ACjBN;AD3FA;EAiHI,YAAA;EACA,iBAAA;EACA,mBAAA;ACnBJ;ADhGA;EAsHM,mBAAA;ACnBN;ADnGA;EA2HI,kBAAA;EACA,+BAAA;EACA,cAAA;ACrBJ;ADyBA;EACE;;IAEE,aAAA;ECvBF;AACF;AACA,wDAAwD","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n.billings-list-page {\n  .muted {\n    color: #64748b;\n    font-size: 0.8rem;\n    margin-top: 2px;\n\n    i {\n      margin-right: 4px;\n      color: #94a3b8;\n    }\n  }\n\n  .p-datatable {\n    background: @white;\n    border: 1px solid #e5e7eb;\n    border-radius: 14px;\n    overflow: hidden;\n    box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n  }\n\n  .p-datatable-thead > tr > th {\n    background: #f9fafb;\n    color: #64748b;\n    font-size: 0.72rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    padding: 0.85rem 1rem;\n    border-bottom: 1px solid #e5e7eb;\n\n    &.num {\n      text-align: right;\n    }\n  }\n\n  .p-datatable-tbody > tr > td {\n    padding: 0.9rem 1rem;\n    border-bottom: 1px solid #f1f5f9;\n    vertical-align: middle;\n\n    &.num {\n      text-align: right;\n    }\n  }\n\n  .p-datatable-tbody > tr:last-child > td {\n    border-bottom: 0;\n  }\n\n  tr.clickable {\n    cursor: pointer;\n    transition: background 0.12s;\n\n    &:hover {\n      background: #f0fdfa;\n    }\n  }\n\n  .number {\n    font-weight: 700;\n    color: #0f172a;\n  }\n\n  .who {\n    display: flex;\n    align-items: center;\n    gap: 0.7rem;\n\n    .avatar {\n      flex: none;\n      width: 34px;\n      height: 34px;\n      border-radius: 50%;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      background: #ccfbf1;\n      color: #0f766e;\n      font-weight: 700;\n      font-size: 0.78rem;\n    }\n\n    .name {\n      font-weight: 600;\n      color: #0f172a;\n    }\n  }\n\n  .amount {\n    font-weight: 700;\n    font-size: 1.02rem;\n    font-variant-numeric: tabular-nums;\n    color: #0f172a;\n  }\n\n  .status-link {\n    display: block;\n    margin-top: 4px;\n    padding: 0;\n    border: 0;\n    background: none;\n    font: inherit;\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: #0f766e;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .actions-col {\n    width: 110px;\n    text-align: right;\n    white-space: nowrap;\n\n    .p-button + .p-button {\n      margin-left: 0.4rem;\n    }\n  }\n\n  .empty {\n    text-align: center;\n    padding: 2.5rem 1rem !important;\n    color: #64748b;\n  }\n}\n\n@media (max-width: 768px) {\n  .billings-list-page th:nth-child(3),\n  .billings-list-page td:nth-child(3) {\n    display: none;\n  }\n}\n",".billings-list-page .muted {\n  color: #64748b;\n  font-size: 0.8rem;\n  margin-top: 2px;\n}\n.billings-list-page .muted i {\n  margin-right: 4px;\n  color: #94a3b8;\n}\n.billings-list-page .p-datatable {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 4px 16px -10px rgba(15, 23, 42, 0.25);\n}\n.billings-list-page .p-datatable-thead > tr > th {\n  background: #f9fafb;\n  color: #64748b;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.billings-list-page .p-datatable-thead > tr > th.num {\n  text-align: right;\n}\n.billings-list-page .p-datatable-tbody > tr > td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n.billings-list-page .p-datatable-tbody > tr > td.num {\n  text-align: right;\n}\n.billings-list-page .p-datatable-tbody > tr:last-child > td {\n  border-bottom: 0;\n}\n.billings-list-page tr.clickable {\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.billings-list-page tr.clickable:hover {\n  background: #f0fdfa;\n}\n.billings-list-page .number {\n  font-weight: 700;\n  color: #0f172a;\n}\n.billings-list-page .who {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n}\n.billings-list-page .who .avatar {\n  flex: none;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #ccfbf1;\n  color: #0f766e;\n  font-weight: 700;\n  font-size: 0.78rem;\n}\n.billings-list-page .who .name {\n  font-weight: 600;\n  color: #0f172a;\n}\n.billings-list-page .amount {\n  font-weight: 700;\n  font-size: 1.02rem;\n  font-variant-numeric: tabular-nums;\n  color: #0f172a;\n}\n.billings-list-page .status-link {\n  display: block;\n  margin-top: 4px;\n  padding: 0;\n  border: 0;\n  background: none;\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #0f766e;\n  cursor: pointer;\n}\n.billings-list-page .status-link:hover {\n  text-decoration: underline;\n}\n.billings-list-page .actions-col {\n  width: 110px;\n  text-align: right;\n  white-space: nowrap;\n}\n.billings-list-page .actions-col .p-button + .p-button {\n  margin-left: 0.4rem;\n}\n.billings-list-page .empty {\n  text-align: center;\n  padding: 2.5rem 1rem !important;\n  color: #64748b;\n}\n@media (max-width: 768px) {\n  .billings-list-page th:nth-child(3),\n  .billings-list-page td:nth-child(3) {\n    display: none;\n  }\n}\n/*# sourceMappingURL=manage-billings.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
